/**
 * Centralised formatting for analytics: days, counts, percentages, dates.
 * Float is always in days.
 */

/** Format float or duration in days (e.g. "12" or "-3") */
export function formatDays(value: number | null | undefined): string {
  if (value == null || (typeof value === 'number' && isNaN(value))) return '—';
  const n = Math.round(value * 10) / 10;
  return n === Math.floor(n) ? String(Math.floor(n)) : n.toFixed(1);
}

/** Format days with "days" suffix; use for display in tables */
export function formatDaysWithUnit(value: number | null | undefined): string {
  if (value == null || (typeof value === 'number' && isNaN(value))) return '—';
  const n = Math.round(value * 10) / 10;
  const s = n === Math.floor(n) ? String(Math.floor(n)) : n.toFixed(1);
  return `${s} days`;
}

/** Format count (integer) */
export function formatCount(value: number | null | undefined): string {
  if (value == null || (typeof value === 'number' && isNaN(value))) return '—';
  return String(Math.round(value));
}

/** Format percentage (one decimal) */
export function formatPct(value: number | null | undefined): string {
  if (value == null || (typeof value === 'number' && isNaN(value))) return '—';
  return `${(Math.round(value * 10) / 10).toFixed(1)}%`;
}

/** Format date for display; returns "—" for invalid/missing */
export function formatDate(value: string | null | undefined): string {
  if (value == null || String(value).trim() === '') return '—';
  try {
    const d = new Date(value);
    if (isNaN(d.getTime())) return '—';
    return d.toLocaleDateString(undefined, { dateStyle: 'short' });
  } catch {
    return '—';
  }
}

/** Format delta for Schedule Health (e.g. "+5 days", "-2") */
export function formatDeltaDays(days: number | null | undefined): string | null {
  if (days == null || (typeof days === 'number' && isNaN(days))) return null;
  const sign = days >= 0 ? '+' : '';
  return `${sign}${Math.round(days)} days`;
}

export function formatDeltaCount(delta: number | null | undefined): string | null {
  if (delta == null || (typeof delta === 'number' && isNaN(delta))) return null;
  const sign = delta >= 0 ? '+' : '';
  return `${sign}${Math.round(delta)}`;
}
